// SplashScreen.js
import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const SplashScreen = ({ finishLoading }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      finishLoading();
    }, 4000); // 4 seconds duration

    return () => clearTimeout(timer);
  }, [finishLoading]);

  const containerVariants = {
    initial: { backgroundColor: "#34C759" },
    animate: { backgroundColor: "#1E8449" },
  };

  const textVariants = {
    initial: { y: -50, opacity: 0 },
    animate: { y: 0, opacity: 1 },
  };

  const logoVariants = {
    initial: { scale: 0, rotate: -180 },
    animate: { scale: 1, rotate: 0 },
  };

  const lineVariants = {
    initial: { width: "0%" },
    animate: { width: "100%" },
  };

  

  return (
    <motion.div
      variants={containerVariants}
      initial="initial"
      animate="animate"
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
      className="fixed inset-0 flex flex-col items-center justify-center p-4"
    >
      <motion.div
        variants={logoVariants}
        initial="initial"
        animate="animate"
        transition={{ type: 'spring', stiffness: 260, damping: 20, delay: 0.2 }}
        className="mb-4 sm:mb-8"
      >
        {/* Glowing pulse effect on logo */}
        <motion.div
          initial={{ boxShadow: '0 0 0px #34C759' }}
          animate={{ boxShadow: [
            '0 0 0px #34C759',
            '0 0 40px 10px #34C759',
            '0 0 0px #34C759',
          ] }}
          transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
          className="w-40 h-40 sm:w-70 sm:h-70 bg-white rounded-full flex items-center justify-center shadow-lg"
        >
          <span className="text-3xl sm:text-4xl font-bold text-[#34C759]">GMWLLP</span>
        </motion.div>
      </motion.div>

      <motion.h1
        variants={textVariants}
        initial="initial"
        animate="animate"
        transition={{ duration: 0.5, delay: 0.5 }}
        className="text-2xl sm:text-4xl font-bold text-white mb-2 sm:mb-4 text-center"
      >
        Gowrihouse Metal Works LLP <br></br>
             Rajapalayam
      </motion.h1>

      <motion.div
        variants={lineVariants}
        initial="initial"
        animate="animate"
        transition={{ duration: 1, delay: 1 }}
        className="h-1 bg-white rounded-full mb-2 sm:mb-4"
        style={{ width: "80%", maxWidth: "300px" }}
      />

      <motion.p
        variants={textVariants}
        initial="initial"
        animate="animate"
        transition={{ duration: 0.5, delay: 1.5 }}
        className="text-white text-lg sm:text-xl text-center"
      >
          Since 1952
      </motion.p>

      {/* Animated Loading Dots */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 2 }}
        className="mt-4 sm:mt-8 text-white text-sm sm:text-base flex items-center justify-center"
      >
        <motion.span
          initial={{ y: 0 }}
          animate={{ y: [0, -8, 0] }}
          transition={{ duration: 0.6, repeat: Infinity, delay: 2, repeatDelay: 0.2 }}
          style={{ display: 'inline-block', marginRight: 2 }}
        >•</motion.span>
        <motion.span
          initial={{ y: 0 }}
          animate={{ y: [0, -8, 0] }}
          transition={{ duration: 0.6, repeat: Infinity, delay: 2.2, repeatDelay: 0.2 }}
          style={{ display: 'inline-block', marginRight: 2 }}
        >•</motion.span>
        <motion.span
          initial={{ y: 0 }}
          animate={{ y: [0, -8, 0] }}
          transition={{ duration: 0.6, repeat: Infinity, delay: 2.4, repeatDelay: 0.2 }}
          style={{ display: 'inline-block' }}
        >•</motion.span>
      </motion.div>
    </motion.div>
  );
};

export default SplashScreen;